import { Environment, getIdentityBaseUrl } from '../../config/env-config';
import { attachParamsToUrl } from './utils';

const identity = (env: Environment) => {
  const identityBaseUrl = getIdentityBaseUrl(env);

  return {
    get_members: {
      scope: 'identity.organization_members:list',
      url: (
        pagenumber: number,
        pagesize: number,
        query: string,
        sortParam?: string,
      ) => {
        const url = `${identityBaseUrl}/organization/members?pagenumber=${pagenumber}&pagesize=${pagesize}`;

        return attachParamsToUrl(url, { query, sort: sortParam });
      },
    },
    get_member: {
      scope: 'identity.organization_members:read',
      url: (id: string) => `${identityBaseUrl}/organization/members/${id}`,
    },
    delete_members: {
      scope: 'identity.organization_members:delete',
      url: `${identityBaseUrl}/organization/members`,
    },
    delete_member_roles: {
      scope: 'identity.organization_members_roles:delete',
      url: (userID: string) =>
        `${identityBaseUrl}/organization/members/${userID}/roles`,
    },
    post_member_roles: {
      scope: 'identity.organization_members_roles:create',
      url: (userID: string) =>
        `${identityBaseUrl}/organization/members/${userID}/roles`,
    },
    get_org_invitations: {
      scope: 'identity.organization_invitations:list',
      url: (
        pagenumber: number,
        pagesize: number,
        query?: string,
        sortParam?: string,
      ) => {
        const url = `${identityBaseUrl}/organization/invitations?pagenumber=${pagenumber}&pagesize=${pagesize}`;

        return attachParamsToUrl(url, { query: query ?? '', sort: sortParam });
      },
    },
    get_org_invitation: {
      scope: 'identity.organization_invitations:read',
      url: (id: string) => `${identityBaseUrl}/organization/invitations/${id}`,
    },
    delete_org_invitation: {
      scope: 'identity.organization_invitations:delete',
      url: (id: string) => `${identityBaseUrl}/organization/invitations/${id}`,
    },
    create_org_invitation: {
      scope: 'identity.organization_invitations:create',
      url: `${identityBaseUrl}/organization/invitations`,
    },
    get_org: {
      scope: 'identity.organization:read',
      url: `${identityBaseUrl}/organization`,
    },
    patch_org: {
      scope: 'identity.organization:update',
      url: `${identityBaseUrl}/organization`,
    },
    get_user: {
      scope: 'identity.user:read',
      url: `${identityBaseUrl}/user`,
    },
    patch_user: {
      scope: 'identity.user:update',
      url: `${identityBaseUrl}/user`,
    },
    get_user_organizations: {
      scope: 'identity.user_organizations:read',
      url: (pagenumber: number, pagesize: number) =>
        `${identityBaseUrl}/user/organizations?pagenumber=${pagenumber}&pagesize=${pagesize}`,
    },
    get_user_roles: {
      scope: 'identity.user_roles:read',
      url: (pagenumber: number, pagesize: number) =>
        `${identityBaseUrl}/user/roles?pagenumber=${pagenumber}&pagesize=${pagesize}`,
    },
    get_roles: {
      scope: 'identity.roles:list',
      url: (pagenumber: number, pagesize: number) =>
        `${identityBaseUrl}/roles?pagenumber=${pagenumber}&pagesize=${pagesize}`,
    },
  };
};

const identityApi = {
  get_members: {
    scope: 'identity.organization_members:list',
    url: '/organization/members',
  },
  get_member: {
    scope: 'identity.organization_members:read',
    url: (id: string) => `/organization/members/${id}`,
  },
  delete_members: {
    scope: 'identity.organization_members:delete',
    url: '/organization/members',
  },
  delete_member_roles: {
    scope: 'identity.organization_members_roles:delete',
    url: (id: string) => `/organization/members/${id}/roles`,
  },
  get_org_invitations: {
    scope: 'identity.organization_invitations:list',
    url: '/organization/invitations',
  },
  get_org_invitation: {
    scope: 'identity.organization_invitations:read',
    url: (id: string) => `/organization/invitations/${id}`,
  },
  delete_org_invitation: {
    scope: 'identity.organization_invitations:delete',
    url: (id: string) => `/organization/invitations/${id}`,
  },
  remove_org_invitation: {
    scope: 'identity.organization_invitations:remove',
    url: (id: string) => `/organization/invitations/remove/${id}`,
  },
  create_org_invitation: {
    scope: 'identity.organization_invitations:create',
    url: '/organization/invitations',
  },
  get_org: {
    scope: 'identity.organization:read',
    url: '/organization',
  },
  get_user: {
    scope: 'identity.user:read',
    url: '/user',
  },
  patch_user: {
    scope: 'identity.user:update',
    url: '/user',
  },
  get_user_organizations: {
    scope: 'identity.user_organizations:read',
    url: '/user/organizations',
  },
  get_user_roles: {
    scope: 'identity.user_roles:read',
    url: '/user/roles',
  },
  get_roles: {
    scope: 'identity.roles:list',
    url: '/roles',
  },
};

export { identity, identityApi };
